import React from 'react';
import { reportClientError } from '../telemetry/clientErrorReporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      source: 'error_boundary',
      errorName: error?.name || 'Error',
      reasonCode: 'render_error',
      componentStack: info?.componentStack || '',
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-fallback" role="alert">
          <h1>Щось пішло не так</h1>
          <p>
            Сталася неочікувана помилка під час відображення сторінки.
            Спробуйте оновити застосунок.
          </p>
          <button type="button" onClick={this.handleReload}>
            Оновити сторінку
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
